import React from 'react';
import styles from '../FeedPage/FeedPage.module.scss';
import { EsgFeedMiddle } from './EsgFeedMiddle';

const EsgFeedComponent = () => (
  <>
    <div className={styles.contentBox}>
      <EsgFeedMiddle />
    </div>
  </>
);

export default EsgFeedComponent;
